import { useRef, useState, useEffect } from 'react'
import { gql, useLazyQuery, useMutation } from '@apollo/client'
import classnames from 'classnames'
import { toast } from 'react-toastify'
import TextField from '@material-ui/core/TextField'
import DatePicker from '@material-ui/lab/DatePicker'
import { Col } from 'reactstrap'

const cols = ['lavadora', 'suciedad', 'responsable', 'supervisor', 'grado', 'prenda', 'hospital', 'reproceso', 'total', 'lavados', 'observaciones']

const query = gql`
  query Registro($start: String!, $end:String!, $turno: Int!) {
        extractoraRegistro(start: $start, end: $end, turno: $turno) {
          id
          lavadora
          observaciones
          responsable
          grado
          hospital
          lavados
          prenda
          reproceso
          suciedad
          total
          supervisor
          turno
        }
    }
`

const mutation = gql`
    mutation Modificar($id: ID!, $name: String!, $value: String!) {
        extractoraModificar(id: $id, name: $name, value: $value) {
          id
        }
    }
`

export default function Modificar () {
  const [start, handleStart] = useState(new Date())
  const [end, handleEnd] = useState(new Date())
  const turnoRef = useRef()
  const [loadData, { data }] = useLazyQuery(query)
  const [send] = useMutation(mutation)

  function submit () {
    const turno = parseInt(turnoRef.current.value)

    if (turno) loadData({ variables: { start, end, turno } })
  }

  useEffect(submit, [start, end, loadData])

  function save (ev) {
    const { id } = ev.target.dataset
    const { name, value } = ev.target

    send({ variables: { id, name, value } })
      .then(() => toast.success('Registros Actualizados!'))
      .catch(function (error) {
        console.log(error)
        toast.error('Error al actualizar registros')
      })
  }

  return (
    <div className='container'>
      <h2 className='text-center'>Modificar reporte de extractoras</h2>
      <div className='row mt-4'>
        <div className='col-md-12'>
          <div className='well well-sm'>
            <form id='addUser' className='form-horizontal'>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='form-group form-row'>
                    <div className='col'>
                      <DatePicker
                        renderInput={(props) => <TextField className='w-50' {...props} />}
                        label='Inicio'
                        value={start}
                        onChange={handleStart}
                      />
                      <DatePicker
                        renderInput={(props) => <TextField className='w-50' {...props} />}
                        label='Fin'
                        value={end}
                        onChange={handleEnd}
                      />
                    </div>
                    <Col md='auto'>
                      <label htmlFor='turno'>Turno:</label>
                      <input
                        type='number' min={1} max={3} name='turno' className='form-control inputChange' id='turno'
                        required='required' ref={turnoRef} onChange={submit}
                      />
                    </Col>
                  </div>
                  <div className='form-group table-responsive'>
                    <table className='table' id='table'>
                      <thead>
                        <tr>
                          <th className='text-left' scope='col'>Lavadora</th>
                          <th className='text-left' scope='col'>Tipo Suciedad</th>
                          <th className='text-left' scope='col'>Responsable</th>
                          <th className='text-left' scope='col'>Supervisor</th>
                          <th className='text-left' scope='col'>Grado de Suciedad</th>
                          <th className='text-left' scope='col'>Tipo de Prenda</th>
                          <th className='text-left' scope='col'>Hospital</th>
                          <th className='text-left' scope='col'>Reproceso</th>
                          <th className='text-left' scope='col'>Codigo Lavado</th>
                          <th className='text-left' scope='col'>Kg lavados</th>
                          <th className='text-left' scope='col'>Observaciones</th>
                        </tr>
                      </thead>
                      <tbody id='rows'>
                        {data && data.extractoraRegistro.map(entry =>
                          <tr key={entry.id}>
                            {
                              cols.map(col =>
                                <td key={col} className={classnames('text-left', { bold: col === 'hospital' })}>
                                  <input data-id={entry.id} type='text' name={col} defaultValue={entry[col] || ''} className='form-control editableInfo' required='required' onBlur={save} />
                                </td>
                              )
                            }
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <br />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
